(function () {

    angular
        .module('app')
        .service('classroomService', classroomService);

    classroomService.$inject = [
        '$http', 'qitanAiContractService'
    ];

    function classroomService($http, qitanAiContractService) {

        function returnData(resp) {
            return resp.data;
        }

        function classroomUrl(name, params) {
            return qitanAiContractService.getClassroomApiUrl(name, params);
        }

        function classParams(profile, classid) {
            return {
                classid : classid || profile.tenant
            };
        }

        function sessionParams(profile, classid, sessionid) {
            return {
                classid : classid || profile.tenant,
                sessionid : sessionid
            };
        }

        function submissionParams(profile, classid, sessionid, submissionid) {
            return {
                classid : classid || profile.tenant,
                sessionid : sessionid,
                submissionid : submissionid
            };
        }

        function getCurrentSession(profile) {
            return $http.get(classroomUrl('currentSession', classParams(profile)))
                .then(returnData);
        }

        function createSession(profile, session) {
            return $http.post(classroomUrl('sessions', classParams(profile)), session)
                .then(returnData);
        }

        function refreshJoinCode(profile, sessionid) {
            return $http.post(classroomUrl('joinCode', sessionParams(profile, profile.tenant, sessionid)))
                .then(returnData);
        }

        function joinClassroom(code) {
            return $http.post(classroomUrl('join'), { code : code })
                .then(returnData);
        }

        function getWallet(profile) {
            return $http.get(classroomUrl('wallet', classParams(profile)))
                .then(returnData);
        }

        function purchaseTokens(profile, amount) {
            return $http.post(classroomUrl('walletPurchase', classParams(profile)), { amount : amount })
                .then(returnData);
        }

        function updateAllocations(profile, allocations) {
            return $http.patch(classroomUrl('allocations', classParams(profile)), {
                allocations : allocations
            }).then(returnData);
        }

        function getAllocations(profile, classid) {
            return $http.get(classroomUrl('allocations', classParams(profile, classid)))
                .then(returnData);
        }

        function getUsage(profile, classid) {
            return $http.get(classroomUrl('usage', classParams(profile, classid)))
                .then(returnData);
        }

        function consumeUsage(profile, classid, usage) {
            return $http.post(classroomUrl('usage', classParams(profile, classid)), usage)
                .then(returnData);
        }

        function invokeAiCapability(profile, classid, payload) {
            return $http.post(qitanAiContractService.getClassroomInvokeUrl(classid || profile.tenant), payload)
                .then(returnData);
        }

        function createAssignment(profile, sessionid, assignment) {
            return $http.post(classroomUrl('assignments', sessionParams(profile, profile.tenant, sessionid)), assignment)
                .then(returnData);
        }

        function getAssignments(profile, classid, sessionid) {
            return $http.get(classroomUrl('assignments', sessionParams(profile, classid, sessionid)))
                .then(returnData);
        }

        function getJoinedStudents(profile, sessionid) {
            return $http.get(classroomUrl('students', sessionParams(profile, profile.tenant, sessionid)))
                .then(returnData);
        }

        function getSubmissions(profile, classid, sessionid) {
            return $http.get(classroomUrl('submissions', sessionParams(profile, classid, sessionid)))
                .then(returnData);
        }

        function createSubmission(profile, classid, sessionid, submission) {
            return $http.post(classroomUrl('submissions', sessionParams(profile, classid, sessionid)), submission)
                .then(returnData);
        }

        function updateSubmissionReview(profile, classid, sessionid, submissionid, review) {
            return $http.patch(classroomUrl('submission', submissionParams(profile, classid, sessionid, submissionid)), review)
                .then(returnData);
        }

        return {
            getCurrentSession : getCurrentSession,
            createSession : createSession,
            refreshJoinCode : refreshJoinCode,
            joinClassroom : joinClassroom,
            getWallet : getWallet,
            purchaseTokens : purchaseTokens,
            getAllocations : getAllocations,
            updateAllocations : updateAllocations,
            getUsage : getUsage,
            consumeUsage : consumeUsage,
            invokeAiCapability : invokeAiCapability,
            createAssignment : createAssignment,
            getAssignments : getAssignments,
            getJoinedStudents : getJoinedStudents,
            getSubmissions : getSubmissions,
            createSubmission : createSubmission,
            updateSubmissionReview : updateSubmissionReview
        };
    }
}());
